import React, { useState, useEffect } from "react";
import {
  Card,
  Modal,
  Form,
  Button,
  Row,
  Col,
  Tab,
  Nav,
  Spinner,
} from "@themesberg/react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  editarPacienteAction,
  cerrarModalEditarAction,
} from "../../actions/pacientesActions";
import DatosAdicionalesRender from "../../components/DatosAdicionales/DatosAdicionalesRender";

export default (props) => {
  const dispatch = useDispatch();

  const { paciente, showModalEditar } = useSelector((state) => state.pacientes);
  const { datosAdicionales, tabsDatosAdicionales } = useSelector(
    (state) => state.datosAdicionales
  );
  const { datosAdicionalesDetalles, loadingDatosAdicionalesDetalles } =
    useSelector((state) => state.datosAdicionalesDetalles);

  const [edicion, guardar] = useState({
    nombre: "",
    apellido_paterno: "",
    apellido_materno: "",
    fecha_nacimiento: "",
    genero: "",
    telefono: "",
    correo_electronico: "",
  });

  const [datosAdicionalesDetallesCargados, setDatosAdicionalesDetallesCargados] = useState(false);

  useEffect(() => {
    setDatosAdicionalesDetallesCargados(loadingDatosAdicionalesDetalles === false);
  }, [loadingDatosAdicionalesDetalles]);

  useEffect(() => {
    guardar({
      id: paciente.id,
      nombre: paciente.nombre,
      apellido_paterno: paciente.apellido_paterno,
      apellido_materno: paciente.apellido_materno,
      fecha_nacimiento: paciente.fecha_nacimiento || "",
      genero: paciente.genero || "",
      telefono: paciente.telefono,
      correo_electronico: paciente.correo_electronico || "",
    });
  }, [paciente]);

  const submitForm = (e) => {
    e.preventDefault();

    const datos_adicionales = {
      detalles: datosAdicionalesDetalles,
      tabla: "CLIENTES",
      id_tabla: paciente.id,
    };
    edicion.datos_adicionales = datos_adicionales;
    dispatch(editarPacienteAction(edicion));
  };

  const handleClose = () => {
    dispatch(cerrarModalEditarAction());
  };

  const onChangeForm = (e) => {
    guardar({
      ...edicion,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <Modal
      as={Modal.Dialog}
      centered
      show={showModalEditar}
      onHide={handleClose}
    >
      <Modal.Header>
        <Modal.Title className="h6">Editar paciente</Modal.Title>
        <Button variant="close" aria-label="Close" onClick={handleClose} />
      </Modal.Header>
      <Form onSubmit={submitForm}>
        <Modal.Body>
          <Tab.Container defaultActiveKey="generales">
            <Row>
              <Nav fill variant="tabs" className="mb-3">
                <Nav.Item>
                  <Nav.Link eventKey="generales">Generales</Nav.Link>
                </Nav.Item>
                {tabsDatosAdicionales.map((dato, index) => (
                  <Nav.Item>
                    <Nav.Link eventKey={dato.tabulador}>
                      {dato.tabulador}
                    </Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
            </Row>
            <Tab.Content>
              <Tab.Pane eventKey="generales" title="Generales">
                <Row>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Nombre(s)*</Form.Label>
                      <Form.Control
                        type="text"
                        name="nombre"
                        placeholder="Nombre"
                        value={edicion.nombre}
                        onChange={onChangeForm}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Apellido paterno*</Form.Label>
                      <Form.Control
                        type="text"
                        name="apellido_paterno"
                        placeholder="Apellido paterno"
                        value={edicion.apellido_paterno}
                        onChange={onChangeForm}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Apellido materno*</Form.Label>
                      <Form.Control
                        type="text"
                        name="apellido_materno"
                        placeholder="Apellido materno"
                        value={edicion.apellido_materno}
                        onChange={onChangeForm}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Form.Group className="mb-3">
                  <Form.Label>Fecha nacimiento</Form.Label>
                  <Form.Control
                    type="date"
                    name="fecha_nacimiento"
                    placeholder="Fecha de nacimiento"
                    value={edicion.fecha_nacimiento}
                    onChange={onChangeForm}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label as="legend" column="sm">
                    Genero
                  </Form.Label>
                  <br />
                  <Form.Check
                    inline
                    type="radio"
                    name="genero"
                    label="Masculino"
                    value="M"
                    checked={edicion.genero == "M"}
                    onChange={onChangeForm}
                  />
                  <Form.Check
                    inline
                    type="radio"
                    name="genero"
                    label="Femenino"
                    value="F"
                    checked={edicion.genero == "F"}
                    onChange={onChangeForm}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Correo electronico</Form.Label>
                  <Form.Control
                    type="email"
                    name="correo_electronico"
                    placeholder="Correo electronico"
                    value={edicion.correo_electronico}
                    onChange={onChangeForm}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Teléfono*</Form.Label>
                  <Form.Control
                    type="number"
                    name="telefono"
                    placeholder="Teléfono"
                    value={edicion.telefono}
                    onChange={onChangeForm}
                  />
                </Form.Group>
              </Tab.Pane>
              {tabsDatosAdicionales.map((dato, index) => (
                <Tab.Pane
                  eventKey={dato.tabulador}
                  title={dato.tabulador}
                  key={index}
                >
                  {datosAdicionalesDetallesCargados === true ? (
                    <>
                      <DatosAdicionalesRender
                        tabulador={dato.tabulador}
                        id_tabla={edicion.id}
                      />
                    </>
                  ) : (
                    <div className="d-flex justify-content-center">
                      <Spinner animation="border" variant="primary" />
                    </div>
                  )}
                </Tab.Pane>
              ))}
            </Tab.Content>
          </Tab.Container>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="link"
            className="text-gray ms-auto"
            onClick={handleClose}
          >
            Cerrar
          </Button>
          <Button type="submit" variant="secondary">
            Actualizar
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};
